<template>
    <div class="v-flex">
        <div style = "width: 25px;">
            <slot name="icon" />
        </div>

        <div
            class = "primary--text c-entry-name"
        >
            {{ entry.name }}
        </div>
    </div>
</template>

<script>

export default {
    name: "PDmsTreeviewEntry",

    props: {
        entry: {

        }
    },

    computed: {
    },
}
</script>

<style scoped>

.c-entry-name {
    padding-top: 2px;
    font-size: 15px;
}

</style>